//@flow
import * as Immutable from 'immutable';

import { SalesChannels } from 'common/models/flow/EntitySettings';
import type { SalesChannelsModelType } from 'common/models/flow/EntitySettings';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

class InternalSalesChannels extends SalesChannels {
    static fromJS(json: SalesChannelsModelType): InternalSalesChannels {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    static getChannelValidationMessage({
        validChannels,
        channels
    }: {
        validChannels: Immutable.List<string>,
        channels: Immutable.List<SalesChannelsModelType>
    }) {
        const invalidChannelIds = channels.reduce((results, { id }) => {
            if (!validChannels.includes(id)) {
                return results.concat(id);
            }
            return results;
        }, []);
        if (invalidChannelIds.length > 0) {
            return nsTranslate('invalidChannelIds', {
                count: invalidChannelIds.length,
                invalidChannelIds: invalidChannelIds.join(', ')
            });
        }
    }
}

export { InternalSalesChannels as SalesChannel };
